import React from 'react';
import ClaimBoxModal from '../../Components/ClaimBoxModal';
import ClaimBoxSuccessModal from '../../Components/ClaimBoxSuccessModal';
export const ClaimBoxContext = /*#__PURE__*/React.createContext({
  startClaimBox: () => {},
  openModal: () => {},
  closeModal: () => {}
});

const ClaimBoxProvider = ({
  children
}) => {
  const [modal, setModal] = React.useState();
  const [claimBoxInfo, setClaimBoxInfo] = React.useState();
  const openModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: true
    }));
  }, []);
  const closeModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: false
    }));
  }, []);
  const startClaimBox = React.useCallback(() => {
    openModal('claimBox');
  }, [openModal]);
  const context = React.useMemo(() => {
    return {
      startClaimBox,
      modal: modal || undefined,
      openModal,
      closeModal
    };
  }, [closeModal, modal, openModal, startClaimBox]);
  return /*#__PURE__*/React.createElement(ClaimBoxContext.Provider, {
    value: context
  }, children, (modal === null || modal === void 0 ? void 0 : modal.claimBox) && /*#__PURE__*/React.createElement(ClaimBoxModal, {
    onSuccess: data => {
      setClaimBoxInfo(data);
      closeModal('claimBox');
      openModal('claimSuccess');
    },
    onClose: () => {
      closeModal('claimBox');
    }
  }), (modal === null || modal === void 0 ? void 0 : modal.claimSuccess) && claimBoxInfo && /*#__PURE__*/React.createElement(ClaimBoxSuccessModal, {
    data: claimBoxInfo,
    onClose: () => {
      closeModal('claimSuccess');
    }
  }));
};

export const useClaimBoxContext = () => {
  const {
    startClaimBox
  } = React.useContext(ClaimBoxContext);
  return {
    startClaimBox
  };
};
export default ClaimBoxProvider;